/* eslint-disable class-methods-use-this */
import { Analytics } from '@payu/paymentsos-types'

import AnalyticsApi from '../../../api/AnalyticsApi'
import filtersDataConverter from './dataConverters/filtersDataConverter'
import graphDataConverter, { GraphData } from './dataConverters/graphDataConverter'
import paymentStagesDataConverter, { MappedDataByPaymentStage } from './dataConverters/paymentStagesDataConverter'
import tabsDataConverter from './dataConverters/tabsDataConverter'
import * as requestBuilder from './requestBuilder'
import { PaymentStageNamesTypes } from '../components/paymentStagesConfig'

class DashboardAnalyticsApi {
  async getPaymentActionsData (
    { from, to, countries, apps, metrics }:
      { from: Date, to: Date, countries: string[], apps: string[], metrics: Analytics.Metric['name'] }
  ): Promise<null | MappedDataByPaymentStage> {
    const request = requestBuilder.forPaymentsFlowButtons(from, to, countries, apps, metrics)
    const data = await AnalyticsApi.postPayments(request)
    return paymentStagesDataConverter(data)
  }

  async getBarsBreakdownData ({
    from,
    to,
    countries,
    apps,
    paymentStage,
    metrics
  }: {
    from: Date,
    to: Date,
    countries: string[],
    apps: string[],
    paymentStage: PaymentStageNamesTypes,
    metrics: Analytics.Metric['name']
  }): Promise<{ [key in Analytics.Dimension]?: null | Record<string, number> }> {
    const requestDatas = requestBuilder.forBreakdown(from, to, countries, apps, paymentStage, metrics)
    const response = {}
    for (const requestData of requestDatas) {
      const data = await AnalyticsApi.postPayments(requestData.request)
      response[requestData.dimension] = tabsDataConverter(data, metrics)
    }
    return response
  }

  async getGraphData ({
    from,
    to,
    granularity,
    countries,
    apps,
    paymentStage,
    metrics,
    dimension
  }: {
    from: Date;
    to: Date;
    granularity: Analytics.TimeRangeGranularity['granularity'],
    countries: string[],
    apps: string[],
    paymentStage: PaymentStageNamesTypes,
    metrics: Analytics.Metric['name'],
    dimension: Analytics.Dimension
  }): Promise<GraphData> {
    const request = requestBuilder.forGraph(from, to, granularity, countries, apps, paymentStage, metrics, dimension)
    const data = await AnalyticsApi.postPayments(request)
    return graphDataConverter(data, metrics, dimension)
  }

  async getFilterData ({
    from,
    to,
    dimension
  }: {
    from: Date;
    to: Date;
    dimension: Analytics.Dimension;
  }): Promise<string[]> {
    const request = requestBuilder.forFilter(from, to, dimension)
    const data = await AnalyticsApi.postPayments(request)
    return filtersDataConverter(data)
  }
}

export default new DashboardAnalyticsApi()
